/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { CreateAllowRegistrationDomainData } from './CreateAllowRegistrationDomainData';
import { CreateBlockRegistrationDomainData } from './CreateBlockRegistrationDomainData';
const CreateRegistrationDomainDataParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['allow', CreateAllowRegistrationDomainData],
    ['block', CreateBlockRegistrationDomainData],
]);
export const CreateRegistrationDomainData = CreateRegistrationDomainDataParser;
